import { HeaderFromPage } from "../../components/common/HeaderFormPage";
import { RequestPasswordChangeForm } from "../../components/RequestPasswordChange";
import styles from "./RequestPasswordChange.module.scss";

export const RequestPasswordChange = () => {
  return (
    <div className={styles.wrapper}>
      <HeaderFromPage title='Account settings' subtitle='Password' />
      <p className={styles.text}>
          Change your password below by filling in the form.
          You will receive an email to change your password if your account is known to us.
      </p>
      <RequestPasswordChangeForm />
    </div>
  );
};
